<template>
  <section class="_menu-section-style">
    <form-section label="Layout" v-model="isExpanded.layout">
      <v-row no-gutters>
        <v-col cols="12" >
          <Select v-model="selectedSection.layout" :items="layoutOptions" :showBorder="true"/>
        </v-col>
      </v-row>
    </form-section>
        
    <form-section label="Título" v-model="isExpanded.title">
      <Texts 
        textType="title" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['alignment']"
      />
    </form-section>

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts 
        textType="subtitle" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"
        useTextArea
      />
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg" :divider="false">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        @update="onUpdateBackground"
      />
    </form-section>

  </section>
</template>

<script>
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import Select from '../../_v2/ui/Select.vue'

export default {
  name: 'PersonalizedFaqSection',
  components: { FormSection, Texts, Select, Background },
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  data: () => ({
    isExpanded: {title: true, subtitle: true, bg: true, layout: true},
    layoutOptions: ['Layout 1', 'Layout 2']    
  }),

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    }
  }    
}
</script>

<style scoped>
</style>